/**
 * 常量
 *
*/

export const GATEWAY_DATA = 'gateway/GATEWAY_DATA';
export const DEMAND_DATA = 'gateway/DEMAND_DATA';
export const GATEWAY_REAL = 'gateway/GATEWAY_REAL';
